import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'lengthconverter'
})
export class LengthConverterPipe implements PipeTransform {
    transform(length: any, excludeLength: boolean = false, excludeUnit: boolean = false, useMinLength: boolean = false, useNbsp: boolean = false) {
        return LengthConverterPipe.transform(length, excludeLength, excludeUnit, useMinLength, useNbsp);
    }

    static transform(length: any, excludeLength: boolean = false, excludeUnit: boolean = false, useMinLength: boolean = false, useNbsp: boolean = false) {

        //  Excluding both area and unit gives no meaning, just flip the values...
        if (excludeLength && excludeUnit) {
            excludeLength = false;
            excludeUnit = false;
        }

        if (length === null || length === undefined) {
            return "-";
        }
         
        if (isNaN(Number(length))) {
            length = length.replace(/\ /g, "");
        }
        if (isNaN(Number(length))) {
            return "-";
        }

        let returnvalue: string;
        let returnUnit: string;

        if (length === 0) {
            if (useMinLength) {
                returnvalue = "50";
                returnUnit = "m";
            } else {
                returnvalue = "-";
                returnUnit = "";
            }
        } else if (length < 100) {
            returnvalue = (Math.ceil(length / 10) * 10).toString();
            returnUnit = "m";
        } else if (length < 500) {
            returnvalue = (Math.ceil(length / 50) * 50).toString();
            returnUnit = "m";
        } else if (length < 1000) {
            returnvalue = (Math.ceil(length / 100) * 100).toString();
            returnUnit = "m";
        } else if (length < 10000) {
            returnvalue = ((Math.ceil(length / 100) * 100) / 1000).toFixed(1);
            returnUnit = "km";
        } else {
            returnvalue = ((Math.ceil(length / 1000) * 1000) / 1000).toString();
            returnUnit = "km";
        }

        if (excludeLength) {
            return returnUnit;
        }
        if (excludeUnit) {
            return returnvalue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, (useNbsp ? "&nbsp;": " "));
        }
        
        return returnvalue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, (useNbsp ? "&nbsp;" : " ")) + (useNbsp ? "&nbsp;" : " ") + returnUnit;
    }
}